import { Divider, Menu } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import MoreIcon from 'react-feather/dist/icons/more-vertical';
import { useAnchorElState } from 'react-use-object-state';
import {
  EntityDescribedPropertyCategory,
  EntityDescribedPropertyFormat,
} from '../../../../../types';
import { JupiterTheme } from '../../../../theme/types';
import useEntityDrawer from '../useEntityDrawer';
import EntityMenuItemQuickEdit from './EntityMenuItemQuickEdit';
import EntityMenuItems from './EntityMenuItems';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    headerTitleClose: {
      color: theme.palette.primary.contrastText,
      width: 24,
      height: 24,
      fontSize: 24,
      margin: 6,
      cursor: 'pointer',
      '&:hover': {
        color: theme.palette.common.white,
      },
    },
    listMenu: {
      marginTop: theme.spacing(7),
      marginRight: 0,
      marginLeft: theme.spacing(-3),
      minWidth: 120,
      maxHeight: 600,
    },
    menuItem: {
      paddingRight: theme.spacing(3.25),
      paddingLeft: theme.spacing(3.25),
      '& b': {
        color: theme.palette.coolGrey[400],
        transition: 'color 0.3s',
      },
      '&:hover': {
        backgroundColor: theme.palette.coolGrey[50],
        '& b': {
          color: theme.palette.primary.main,
        },
      },
    },
    menuIcon: {
      color: theme.palette.primary.dark,
      marginRight: theme.spacing(1.25),
      transition: 'color 0.3s',
      ':hover > &': {
        color: theme.palette.primary.dark,
      },
    },
    webLink: {
      '& a, & div': {
        color: 'inherit',
        textDecoration: 'none',
        display: 'flex',
      },
    },
    graphIcon: {
      strokeWidth: 2,
    },
  });
});

export const EntityMenu = () => {
  const { anchorEl, clearAnchorEl, setAnchorEl } = useAnchorElState(null);
  const classes = useStyles();
  const {
    editModal,
    entity: { entity },
  } = useEntityDrawer();

  if (!entity) return null;

  const entityBooleans = editModal
    ? entity.properties.filter((prop) => {
        if (prop.category !== EntityDescribedPropertyCategory.PROPERTY)
          return false;
        if (prop.source !== 'Entity') return false;
        return prop.type === EntityDescribedPropertyFormat.BOOLEAN;
      })
    : [];

  const nonEntityBooleans = editModal
    ? entity.properties.filter((prop) => {
        if (prop.category !== EntityDescribedPropertyCategory.PROPERTY)
          return false;
        if (prop.source === 'Entity') return false;
        return prop.type === EntityDescribedPropertyFormat.BOOLEAN;
      })
    : [];

  const tagBooleans = editModal
    ? entity.properties.filter((prop) => {
        if (prop.category !== EntityDescribedPropertyCategory.TAG) return false;
        return prop.type === EntityDescribedPropertyFormat.BOOLEAN;
      })
    : [];
  return (
    <>
      <MoreIcon
        className={classes.headerTitleClose}
        aria-label="Open Menu"
        aria-haspopup="true"
        aria-controls="simple-menu"
        role="button"
        onClick={setAnchorEl}
        data-testid="menu-handle"
      />
      <Menu
        aria-label="Simple Menu"
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={clearAnchorEl}
        className={classes.listMenu}
      >
        <EntityMenuItems />
        {!!entityBooleans.length && <Divider />}
        {entityBooleans.map(({ name, value }) => {
          return (
            <EntityMenuItemQuickEdit
              key={'entry' + name}
              name={name}
              value={value}
            />
          );
        })}
        {!!nonEntityBooleans.length && <Divider />}
        {nonEntityBooleans.map(({ name, value }) => {
          return (
            <EntityMenuItemQuickEdit
              key={'nonEntity' + name}
              name={name}
              value={value}
            />
          );
        })}
        {!!tagBooleans.length && <Divider />}
        {tagBooleans.map(({ name, value }) => {
          return (
            <EntityMenuItemQuickEdit
              key={'nonEntity' + name}
              name={name}
              value={value}
              tag
            />
          );
        })}
      </Menu>
    </>
  );
};

export default EntityMenu;
